import { render, staticRenderFns } from "./NotificationHistory.vue?vue&type=template&id=b9aef2b0&scoped=true"
import script from "./NotificationHistory.vue?vue&type=script&lang=js"
export * from "./NotificationHistory.vue?vue&type=script&lang=js"
import style0 from "./NotificationHistory.vue?vue&type=style&index=0&id=b9aef2b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9aef2b0",
  null
  
)

export default component.exports